<template>
  <div :class="hasBorder ? 'border-right' : ''">
    <div class="row">
      <div class="col">
        <div class="d-flex">
          <icon-view
            :icon="icon"
            :icon-background="iconColor"
            icon-color="#fff"
            variant="custom-icon"
            width="w-auto"
          />
          <div class="color-black font-weight-bold font-20">{{ title }}</div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <div class="d-flex flex-column">
          <div class="color-secondary-6 font-14">Total de Ajustes:</div>
          <div class="color-black font-weight-bold font-25">
            {{ serviceTotal }}
          </div>
        </div>
      </div>
      <div v-if="showObjection" class="col">
        <div class="d-flex flex-column">
          <div class="color-secondary-6 font-14">Objetados:</div>
          <div class="color-black font-weight-bold font-25">
            {{ objectionTotal }}
          </div>
        </div>
      </div>
      <div class="col">
        <div class="d-flex flex-column">
          <div class="color-secondary-6 font-14">Monto Total:</div>
          <div class="color-black font-weight-bold font-25">
            {{ amount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
export default {
  name: 'TotalAmountAdjustmentView',
  components: {
    IconView,
  },
  props: {
    title: {
      type: String,
      default: () => '',
    },
    hasBorder: {
      type: Boolean,
      default: () => false,
    },
    serviceTotal: {
      type: Number,
      required: true,
    },
    amount: {
      type: String,
      required: true,
    },
    showObjection: {
      type: Boolean,
      default: () => false,
    },
    objectionTotal: {
      type: Number,
      default: () => 0,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: () => 'color-green',
    },
  },
};
</script>

<style scoped lang="scss">
.icon-block {
  font-size: 28px;
  margin-right: 12px;
  margin-top: 4px;
}

::v-deep .custom-icon {
  .dot {
    width: 30px !important;
    height: 30px !important;
    .title-icon {
      margin-top: 2px;
      font-size: 15px;
      margin-bottom: 4px;
    }
  }
}
</style>
